exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-5dc6594c] {\n  font-size: 54px;\n  line-height: 72px;\n  margin-bottom: 20px;\n  font-weight: 700;\n  color: rgb(0, 0, 0);\n  letter-spacing: 1px;\n}\n@media only screen and (max-width: 575px) {\nh2[data-v-5dc6594c] {\n    font-size: 35px;\n    line-height: 45px;\n}\n}\ninput[data-v-5dc6594c]:disabled {\n  background: gainsboro;\n}\n", ""]);

// exports
